import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import {
  nameFirme,
  paymentName,
  deliveryName,
  payName
} from "@/helpers/reference";

const state = {
  reportingMonth: {
    data: []
  },
  paymentSender: {
    data: []
  },
  inetPayNotConnectedPayments: {
    data: []
  },
  personalAccountsPayments: {
    data: []
  },
  controlInetPaysReloadAllGrids: false,
  controlInetPaysReloadUpDownGrids: false
};

const mutations = {
  setReportingMonth: (state, payload) => (state.reportingMonth = payload),
  clearReportingMonth: state => (state.reportingMonth = { data: [] }),
  setPaymentSender: (state, payload) => (state.paymentSender = payload),
  clearPaymentSender: state => (state.paymentSender = { data: [] }),
  setInetPayNotConnectedPayments: (state, payload) =>
    (state.inetPayNotConnectedPayments = payload),
  clearInetPayNotConnectedPayments: state =>
    (state.inetPayNotConnectedPayments = { data: [] }),
  setPersonalAccountsPayments: (state, payload) =>
    (state.personalAccountsPayments = payload),
  clearPersonalAccountsPayments: state =>
    (state.personalAccountsPayments = { data: [] }),
  setControlInetPaysReloadAllGrids: (state, payload) =>
    (state.controlInetPaysReloadAllGrids = payload),
  setControlInetPaysReloadUpDownGrids: (state, payload) =>
    (state.controlInetPaysReloadUpDownGrids = payload)
};

const actions = {
  async getReportingMonth({ commit, rootState }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInternetPay",
            funcname: "wbGetDate"
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setReportingMonth", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getPaymentSender({ commit, rootState }, { datebank }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInternetPay",
            funcname: "wbGetFirme",
            datebank: `${datebank}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPaymentSender", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getInetPayNotConnectedPayments(
    { commit, rootState },
    { codefirme, datebank, ptransferid }
  ) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInternetPay",
            funcname: "wbGetInetPay",
            codefirme: `${codefirme}`,
            datebank: `${datebank}`,
            ptransferid: `${ptransferid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setInetPayNotConnectedPayments", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getPersonalAccountsPayments(
    { commit, rootState },
    { codefirme, dateclient, npack, transferid, ptransferid }
  ) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInternetPay",
            funcname: "wbGetPayReestr",
            codefirme: `${codefirme}`,
            dateclient: `${dateclient}`,
            npack: `${npack}`,
            transferid: `${transferid}` === "" ? "0" : `${transferid}`,
            ptransferid: `${ptransferid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPersonalAccountsPayments", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async moveToNextMonth({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInetPayBehavior",
            funcname: "wbMovePackToOtherMonth",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setControlInetPaysReloadAllGrids", true);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async cancelReceivedRegistry({ commit, rootState }, { transferid }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInetPayBehavior",
            funcname: "wbCancelTransfer",
            transferid: `${transferid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setControlInetPaysReloadUpDownGrids", true);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async cancelSubscriberPayment({ commit, rootState }, { paymentid }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbInetPayBehavior",
            funcname: "wbDelInetPay",
            paymentid: `${paymentid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setControlInetPaysReloadUpDownGrids", true);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  reportingMonth: state => {
    let items = [];
    state.reportingMonth.data.forEach(item => {
      const datebank = Vue.moment(item.datebank, "DD.MM.YYYY");
      item["datebanktext"] = `${datebank.format("MMMM")} ${datebank.format(
        "YYYY"
      )}`;
      items.push(item);
    });
    return items;
  },
  paymentSender: (state, rootState) => {
    let items = [];
    state.paymentSender.data.forEach(item => {
      (item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      )),
        items.push(item);
    });
    return items;
  },
  inetPayNotConnectedPayments: state => state.inetPayNotConnectedPayments.data,
  personalAccountsPayments: (state, rootState) => {
    let items = [];
    state.personalAccountsPayments.data.forEach(item => {
      item["namepay"] = paymentName(item.statuspay);
      item["namedelivery"] = deliveryName(item.statusdeliv);
      item["nameplat"] = payName(rootState.params.codepay.data, item.codeplat);
      items.push(item);
    });
    return items;
  },
  controlInetPaysReloadAllGrids: state => state.controlInetPaysReloadAllGrids,
  controlInetPaysReloadUpDownGrids: state =>
    state.controlInetPaysReloadUpDownGrids
};

export default { state, mutations, actions, getters };
